import { render, staticRenderFns } from "./BoxChart.vue?vue&type=template&id=866b4c4c&scoped=true&"
import script from "./BoxChart.vue?vue&type=script&lang=js&"
export * from "./BoxChart.vue?vue&type=script&lang=js&"
import style0 from "./BoxChart.vue?vue&type=style&index=0&id=866b4c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866b4c4c",
  null
  
)

export default component.exports